//working home intoro
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../Layout/Layout";
import OrdersColumnChart from "./Charts/OrdersColumnChart";

import PieChart from "./Charts/PieChart";
import { useNavigate } from "react-router-dom";
//Redux
import { useSelector } from "react-redux"; //useDispatch
import customerItemService from "../../services/construction_appCommonService";
import LoaderSmall from "../../Components/LoaderSmall";
import ItemService from "../../services/construction_appCommonService";
import {
  BadgeCheck,
  Ban,
  Building2,
  CheckCircle,
  ClipboardCheck,
  ClipboardList,
  FileEdit,
  MessageCircleQuestion,
  RotateCcw,
  XCircle,
} from "lucide-react";

import {
  // formatNumberShort,
  getCurrentDate,
} from "../../common/Validations";
import DatePickerComponent from "./Charts/FilterComponent/DatePickerComponent";
// import SupplierConstants from "../../common/SupplierConstants";
import CategoryCard from "../../Components/Cards/CategoryCard";
import SCConstants from "../../common/SCConstants";
import SupplierConstants from "../../common/SupplierConstants";
import CollapseCard from "../../Components/Collapsecard/Collapsecard";
const Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const navigateToMainPage = (page) => {
    if (page === "supplier") {
      navigate(SupplierConstants.SUPPILER_LIST);
    } else if (page === "job") {
      navigate(SCConstants.CONSTRUCTION_JOB_LIST);
    } else if (page === "enq") {
      navigate(SCConstants.CONSTRUCTION_ENTRY_LIST);
    } else if (page === "estimation") {
      navigate(SCConstants.CONSTRUCTION_ESTIMATE_SPECIFICATION_LIST);
    } else if (page === "qtn") {
      navigate(SCConstants.CONSTRUCTION_QUOTATION_LIST);
    }
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");
  const [filterShow, setFilterShow] = useState(false);
  const [supplierStatusColChart, setSupplierStatusColChart] = useState("");
  const [supplierStatusColChartStatus, setSupplierStatusColChartStatus] =
    useState(false);
  // eslint-disable-next-line
  const [hideItem, setHideItem] = useState(false);

  const [getEstimationDraft, setEstimationDraft] = useState("");
  const [getEstimationRevision, setEstimationRevision] = useState("");
  const [getEstimationCreated, setEstimationCreated] = useState("");
  const [getEstimationRevised, setEstimationRevised] = useState("");
  const [getEstimationRejected, setEstimationRejected] = useState("");
  const [getEstimationCanelled, setEstimationCancelled] = useState("");
  const [estimationStatusColChartStatus, setEstimationStatusColChartStatus] =
    useState(false);

  const [quotatationStatusColChartStatus, setquotatationStatusColChartStatus] =
    useState(false);

  const [quotatationtatusColChart, setQuotatationtColChart] = useState("");

  const [getEstimationPieChart, setEstimationPieChart] = useState("");
  const [estimationatusColChart, setEstimationatusColChart] = useState("");

  const attachQueryNames = (filterData) => {
    return {
      ...filterData,
      queryName1: "Yearly_Pie_Estimation_Chart",
      queryName2: "Monthly_Pie_Estimation_Chart",
      queryName:
        filterData.action === "Yearly"
          ? "Yearly_Pie_Estimation_Chart"
          : filterData.action === "Monthly"
            ? "Monthly_Pie_Estimation_Chart"
            : "Custom_Pie_Estimation_Chart",
    };
  };

  const pieChart = async (filterData) => {
    setEstimationStatusColChartStatus(true);

    // Add static + dynamic chart params
    let payload = {
      ...filterData,
      module: "estimation",
      chartType: "doughnut",
    };

    // Attach Yearly / Monthly / Custom query names
    payload = attachQueryNames(payload);

    // API Call
    await ItemService.dashboardHb(payload).then((item) => {
      if (item?.status === 200) {
        item.data.module = "estimation";
        item.data.module = "job";
        item.data.module = "quotation";
        setEstimationPieChart(item?.data);
        // console.log(item?.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setEstimationStatusColChartStatus(false);
  };

  // sum one series data array
  const sumSeries = (seriesItem) => {
    if (!seriesItem?.data) return 0;
    return seriesItem.data.reduce((sum, v) => sum + Number(v || 0), 0);
  };

  // get total by status name from dashboard response
  const getTotalByStatusName = (dashboardData, statusName) => {
    const s = dashboardData?.series?.find((s) => s.name === statusName);
    return sumSeries(s);
  };

  const estimationChart = async (filterData) => {
    setEstimationStatusColChartStatus(true);
    const payload = { ...filterData, module: "estimation", chartType: "bar" };

    try {
      const item = await ItemService.dashboardHb(payload);
      if (item?.status === 200) {
        const data = item.data;
        data.module = "estimation";
        setEstimationatusColChart(data); // existing bar chart state
        const totalDraft = getTotalByStatusName(data, "Estimation Draft");
        const totalCreated = getTotalByStatusName(data, "Estimation Created");
        const totalRevision = getTotalByStatusName(data, "Estimation Revision");
        const totalRevised = getTotalByStatusName(data, "Estimation Rivised");
        const totalRejected = getTotalByStatusName(data, "Estimation Rejected");
        const totalCancelled = getTotalByStatusName(
          data,
          "Estimation Cancelled",
        );

        setEstimationDraft(totalDraft);
        setEstimationCreated(totalCreated);
        setEstimationRevision(totalRevision);
        setEstimationRevised(totalRevised);
        setEstimationRejected(totalRejected);
        setEstimationCancelled(totalCancelled);
      } else {
        toast.error(item?.message || "Please try again for Estimation Chart", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (e) {
      toast.error("Something went wrong in estimation chart", {
        duration: 3000,
        position: "top-right",
      });
    }

    setEstimationStatusColChartStatus(false);
  };

  const quotatinChart = async (filterData) => {
    setquotatationStatusColChartStatus(true);
    filterData.module = "quotation";
    filterData.chartType = "bar";

    await customerItemService.dashboardHb(filterData).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        item.data.module = "quotation";
        setQuotatationtColChart(item?.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setquotatationStatusColChartStatus(false);
  };

  useEffect(() => {
    let defaultFilter = {
      // action: "Monthly",
      // month: currentMonth,
      // year: currentYear,
      module: "estimation",
      action: "Monthly",
      // month: currentMonth,
      // year: currentYear,
      fromDate: "2025-12-01",
      toDate: "2026-12-20",
      // searchTerm: getemployee?.employeeCode,
      // filterChartField: "userId",
    };
    const defaultFilterPiechart = {
      module: "Estimation",
      action: "Custom",
      chartType: "pie",
      queryName1: "Yearly_Pie_Estimation_Chart",
      queryName2: "Monthly_Pie_Estimation_Chart",
      queryName: "Custom_Pie_Estimation_Chart",
      // month: currentMonth,
      // year: currentYear,
      fromDate: "2025-12-01",
      toDate: "2026-12-29",
    };

    // loadTotalJobCounts();
    // loadEstimationCount();
    // loadQuotationCount();
    //loadEstimationPending(); //estimation pending count
    // loadEnquiryCount();

    // jobsChart(defaultFilter);
    quotatinChart(defaultFilter);
    estimationChart(defaultFilter);
    pieChart(defaultFilterPiechart);

    //loadEstimationPending(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Suppliers Chart
  const suppliersChart = async (filterData) => {
    setSupplierStatusColChartStatus(true);
    filterData.module = "order";
    filterData.chartType = "column";

    await customerItemService.dashboard(filterData).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        item.data.module = "order";
        setSupplierStatusColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setSupplierStatusColChartStatus(false);
  };
  // On Filtered Data
  const handleFilterData = async (filter) => {
    // console.log(">> filter", filter);

    await suppliersChart(filter);
    // await poChart(filter);
  };

  useEffect(() => {
    let defaultFilter = {
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
    };
    suppliersChart(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const categoryConfigs = [
    {
      title: "Enquiry",
      icon: MessageCircleQuestion,
      fetchFunction: () =>
        ItemService.generateCustomerQuery({
          queryName: "Get_ENQUIRY_LIST",
        }),
      navigateKey: "enq",
    },
    {
      title: "Total Job",
      // queryName: "Get_Quotation_Count_value",
      fetchFunction: () =>
        ItemService.generateCustomerQuery({
          queryName: "Get_JOB_LIST",
        }),
      icon: Building2,
      navigateKey: "job",
    },
    {
      title: "Quotation",
      fetchFunction: () =>
        ItemService.generateCustomerQuery({
          queryName: "Get_QUOTATION_LIST",
        }),
      icon: ClipboardCheck,
      navigateKey: "qtn",
    },
    {
      title: "Estimation",
      fetchFunction: () =>
        ItemService.generateCustomerQuery({
          queryName: "Get_ESTIMATION_LIST",
        }),
      icon: ClipboardList,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Draft",
      value: getEstimationDraft,
      icon: FileEdit,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Created",
      value: getEstimationCreated,
      icon: CheckCircle,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Revision",
      value: getEstimationRevision,
      icon: RotateCcw,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Revised",
      value: getEstimationRevised,
      icon: BadgeCheck,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Rejected",
      value: getEstimationRejected,
      icon: XCircle,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Canceled",
      value: getEstimationCanelled,
      icon: Ban,
      navigateKey: "estimation",
    },
  ];
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Dashboard detailed page</p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            <section className="section">
              <section className="section">
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="">
                    {/* <h5 className="card-title mb-3">My Category</h5> */}
                    <div className="row g-3">
                      {categoryConfigs.map((item, index) => (
                        <div
                          className="col-12 col-md-6 col-lg-3 px-2"
                          key={index}
                        >
                          <CategoryCard
                            {...item}
                            onClick={() => navigateToMainPage(item.navigateKey)}
                          />
                        </div>
                      ))}
                    </div>
                  </CollapseCard>
                </div>
              </section>
              {filterShow && (
                <DatePickerComponent
                  getfiltereddata={handleFilterData}
                  cancelAction={() => setFilterShow(!filterShow)}
                />
              )}
              <div className="row">
                {/* Orders */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Jobs">
                    {/* <h5 className="card-title">Jobs</h5> */}

                    {/* <div id="columnChart"></div> */}
                    <LoaderSmall isLoading={supplierStatusColChartStatus} />
                    <h6>
                      {!supplierStatusColChartStatus ? (
                        <OrdersColumnChart
                          key="order"
                          chartdata={supplierStatusColChart}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </CollapseCard>
                </div>

                {/* Esitmation column chart */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Esitmation">
                    <LoaderSmall isLoading={estimationStatusColChartStatus} />
                    <h6>
                      {!estimationStatusColChartStatus ? (
                        <OrdersColumnChart
                          key="order"
                          chartdata={estimationatusColChart}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </CollapseCard>
                </div>

                {/* quotation column chart */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Quotation">
                    {/* <h5 className="card-title">Quotation</h5> */}

                    {/* <div id="columnChart"></div> */}
                    <LoaderSmall isLoading={quotatationStatusColChartStatus} />
                    <h6>
                      {!quotatationStatusColChartStatus ? (
                        <OrdersColumnChart
                          key="order"
                          chartdata={quotatationtatusColChart}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </CollapseCard>
                </div>

                {/* Statistics */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Statistics">
                    {/* <h5 className="card-title">Statistics</h5> */}
                    <PieChart
                      chartData={{
                        labels:
                          getEstimationPieChart?.categories?.map(
                            (x) => x ?? "Unknown",
                          ) || [],
                        series: getEstimationPieChart?.series || [],
                      }}
                    />
                  </CollapseCard>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Dashboard;
